import { render, staticRenderFns } from "./PremiumContentModal.vue?vue&type=template&id=c6507d22&scoped=true&"
import script from "./PremiumContentModal.vue?vue&type=script&lang=js&"
export * from "./PremiumContentModal.vue?vue&type=script&lang=js&"
import style0 from "./PremiumContentModal.vue?vue&type=style&index=0&id=c6507d22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6507d22",
  null
  
)

export default component.exports